import { render, staticRenderFns } from "./PopoverWrapper.vue?vue&type=template&id=6beb273c&"
import script from "./PopoverWrapper.vue?vue&type=script&lang=js&"
export * from "./PopoverWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PopoverWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports